<i18n src="./langset.json"></i18n>
<template>
  <el-watermark :content="markContentStr" :font="{ color: 'rgba(0, 0, 0, 0.05)' }">
    <div class="app-container">
      <!-- 顶部导航栏 - 样式优化 -->
      <div v-show="menuObj.show" class="menu-search" @click="menuClickFn">
        <div style="display: flex; align-items: center; height: 150px; padding: 0 30%">
          <el-select
            @change="onMenuChangeFn"
            style="box-shadow: 5px 5px 10px black; border-radius: 5px; padding: 20px; opacity: 1; background: white"
            v-model.trim="menuObj.value"
            filterable
            placeholder="请输入菜单名称"
            :filter-method="filterMethodFn"
          >
            <el-option v-for="item in menuObj.options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">
                <el-icon size="12">
                  <Menu />
                </el-icon>
                <span style="font-size: 13px; line-height: 13px; height: 13px; margin-left: 5px">
                  <span v-html="item.label"></span>
                </span>
              </span>
              <span style="float: right; color: var(--el-text-color-secondary); font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="navbar">
        <div class="left-menu">
          <div class="logo">
            <!-- <img src="/public/saasLogo.png" alt=""> -->
            <span style="line-height: 20px" class="pc-title">{{ t("SaaS管理系统") }}</span>
            <span style="line-height: 20px" class="mobile-title">SaaS</span>
            <span @click="onClickFn" style="cursor: pointer; margin-left: 5px; height: 20px">
              <el-icon v-if="menuCollapse" :size="20">
                <Expand />
              </el-icon>
              <el-icon v-else :size="20">
                <Fold />
              </el-icon>
            </span>
          </div>
        </div>
        <div class="right-menu">
          <div v-if="false">
            <el-dropdown @visible-change="visibleChangeFn">
              <el-icon :size="20" class="menu-serach" style="margin-right: 15px; color: wheat">
                <Star />
              </el-icon>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="gotoUrl(obj)" v-for="obj in collectMenu" :key="obj.path">{{ obj.title }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <el-dropdown teleported placement="bottom-end" style="margin-right: 10px" v-if="user.tenantList && user.tenantList.length > 1">
            <div class="el-dropdown-link">
              <span class="tenant-name">{{ currentTenant?.tenantName || currentTenant?.tenantCode }}</span>
              <el-icon color="#fff">
                <arrow-down></arrow-down>
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="tenant in user.tenantList" :key="tenant.tenantId" @click="changeTenant(tenant)">{{
                  tenant.tenantName || tenant.tenantCode
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <span v-else style="margin-right: 10px; font-size: 15px; color: #ffffff">
            {{ currentTenant?.tenantName || currentTenant?.tenantCode }}</span
          >
          <el-dropdown teleported placement="bottom-end">
            <div class="el-dropdown-link">
              <el-avatar :size="30" :src="`${user.avatar}`" class="avatar" />
              <span class="user-name">
                <b class="nickName">{{ user.nickName }}</b>
                <el-divider direction="vertical" class="divider"></el-divider>
                <b class="roleName">{{ currentRole?.roleName || "游客" }}</b>
              </span>
              <el-icon color="#fff">
                <arrow-down></arrow-down>
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="toPersonalCenter">
                  {{ t("个人中心") }}
                </el-dropdown-item>
                <el-dropdown-item v-if="user.roleList && user.roleList.length > 1" @click="changeRole">{{ t("切换角色") }}</el-dropdown-item>
                <el-dropdown-item @click="logout">
                  {{ t("退出登录") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <div class="h5-entry" @click="goToWorkplace">简易</div>
        </div>
      </div>
      <div class="main-container">
        <!-- 左侧菜单 -->
        <el-aside class="sidebar">
          <el-menu
            v-show="isCollapsed"
            :unique-opened="false"
            :default-openeds="['']"
            :collapse="menuCollapse"
            style="height: 100%; overflow-y: auto; padding-bottom: 50px"
            size="small"
            router
            :default-active="activeMenu"
            text-color="#0d0e0e"
            active-text-color="#409EFF"
            @select="handleMenuSelect"
          >
            <!-- 一级菜单 -->
            <el-sub-menu v-for="amenu in menuData" :index="amenu.path" :key="amenu.path">
              <template #title>
                <el-icon>
                  <component :is="amenu.meta.icon" />
                </el-icon>
                <span>{{ amenu.name }}</span>
              </template>

              <!-- 二级菜单 -->
              <template v-for="(bmenu, j) in amenu.children" :key="j">
                <!-- 有三级菜单的情况 -->
                <el-sub-menu v-if="bmenu.children?.length" :index="resolvePath(bmenu.path)">
                  <template #title>
                    <el-icon v-if="bmenu.meta?.icon">
                      <component :is="bmenu.meta.icon" />
                    </el-icon>
                    <span>{{ bmenu.name }}</span>
                  </template>

                  <!-- 三级菜单 -->
                  <el-menu-item v-for="(cmenu, k) in bmenu.children" :key="k" :index="resolvePath(bmenu.path, cmenu.path)">
                    <template #title>
                      <!-- <el-icon v-if="cmenu.meta?.icon">
                      <component :is="cmenu.meta.icon" />
                      </el-icon>-->
                      <span>{{ cmenu.name }}</span>
                    </template>
                  </el-menu-item>
                </el-sub-menu>
                <!-- 无三级菜单的情况 -->
                <el-menu-item v-else :index="resolvePath(bmenu.path)">
                  <template #title>
                    <el-icon v-if="bmenu.meta?.icon">
                      <component :is="bmenu.meta.icon" />
                    </el-icon>
                    <span>{{ bmenu.name }}</span>
                  </template>
                </el-menu-item>
              </template>
            </el-sub-menu>
          </el-menu>
        </el-aside>
        <!-- 主内容区 -->
        <div class="app-main" v-if="menuData[0]">
          <!-- 标签页导航 -->
          <div class="tags-view-container">
            <el-tabs class="top-tab" v-model="activeTab" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
              <el-tab-pane v-for="tab in visitedTabs" :key="tab.path" :label="tab.title" :name="tab.path"></el-tab-pane>
            </el-tabs>
            <el-dropdown style="font-size: 18px; width: 40px; margin-left: 10px">
              <span class="el-dropdown-link">
                <el-icon>
                  <MoreFilled />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="closeTagFn('others')">
                    {{ t("关闭其他") }}
                  </el-dropdown-item>
                  <el-dropdown-item @click="closeTagFn('all')">
                    {{ t("关闭所有") }}
                  </el-dropdown-item>
                  <!--  <el-dropdown-item @click="closeTagFn('collect')">{{
                    t("收藏当前页")
                  }}</el-dropdown-item>-->
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <!-- 内容区域 -->
          <router-view v-slot="{ Component, route }">
            <transition name="fade-transform" mode="out-in">
              <keep-alive :include="cachedViews">
                <component :is="Component" :key="`${tenantComponentKey}-${route.fullPath}`"></component>
              </keep-alive>
            </transition>
          </router-view>
        </div>
      </div>
      <!-- 底部备案信息 -->
      <footer class="app-footer">
        备案号：
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">湘ICP备2025113651号-4</a>
      </footer>
      <!-- size根据页面宽度动态调整 -->
      <el-drawer v-model="drawerPannel" title="个人中心" direction="rtl" append-to-body :size="drawerSize">
        <personalCenter :user="user" @update-user="updateUser" @close-pannel="drawerPannel = false" />
      </el-drawer>
      <changeRoleComp ref="changeRoleRef" :roleList="user.roleList" @update-role="updateRole" />
    </div>
  </el-watermark>
</template>
<script setup>
import { ref, computed, watch, onBeforeMount, provide, reactive, onUnmounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import personalCenter from "./personalCenter/index.vue";
import comCueBox from "../comCue/comCue";
import { removeToken, setTenant, getTenant, setCurrentRole, setUserInfo } from "@/utils/auth";
import request from "@/utils/request";
import API_CONFIG from "./api.json";
import { useI18n } from "vue-i18n";
import changeRoleComp from "./changeRole.vue";
import { setMenus, getVisitedTabs, setVisitedTabs, getActiveTab, setActiveTab } from "@/utils/storeMenu.ts";
import { getUserRouteParams, setUserRouteParams } from "@/utils/routeParams.ts";
import { getAllDictData } from "@/utils";
import { useEventBus } from "@/utils/eventBus";
import { initDynamicRoutes, resetDynamicRoutes } from "@/router/index";

const tenantComponentKey = ref(0);
const collectMenuId = "COLLECT_MENU";
const { t } = useI18n();
const drawerPannel = ref(false);
const markContentStr = ref([]);
const currentRole = ref({});
const currentTenant = ref(null);
const changeRoleRef = ref(null);
const drawerSize = computed(() => {
  return window.innerWidth > 640 ? "35%" : "85%";
});
// 添加从本地存储加载数据的函数
const loadVisitedTabsFromStorage = () => {
  try {
    const savedTabs = getVisitedTabs();
    const savedActiveTab = getActiveTab();
    if (savedTabs) {
      visitedTabs.value = savedTabs;
    }
    if (savedActiveTab) {
      activeTab.value = savedActiveTab;
    }
  } catch (error) {
    console.error("Failed to load visited tabs from storage:", error);
  }
};

// 添加保存数据到本地存储的函数
const saveVisitedTabsToStorage = () => {
  try {
    setVisitedTabs(visitedTabs.value);
    setActiveTab(activeTab.value);
  } catch (error) {
    console.error("Failed to save visited tabs to storage:", error);
  }
};

const markContent = (() => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();
  return `${year}${t("年")}${month}${t("月")}${day}${t("日")} ${hour}:${minute}:${second}`;
})();

const setLocallMenuFn = (type, data) => {
  if (type === "add") {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(collectMenuId)) || [];
    } catch (error) {
      list = [];
    }
    list.push(data);
    localStorage.setItem(collectMenuId, JSON.stringify(list));
  } else if (type === "delete") {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(collectMenuId)) || [];
    } catch (error) {
      list = [];
    }
    list = list.filter((o) => o.path != data.path);
    localStorage.setItem(collectMenuId, JSON.stringify(list));
  } else {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(collectMenuId)) || [];
    } catch (error) {
      list = [];
    }
    return list;
  }
};
const visibleChangeFn = (s) => {
  if (s) {
    collectMenu.value = setLocallMenuFn();
  }
};
const gotoUrl = ({ path }) => {
  router.push(path);
};
const collectMenu = ref([]);
const onClickFn = () => {
  isCollapsed.value = true;
  if (menuCollapse.value) {
    menuCollapse.value = false;
  } else {
    menuCollapse.value = true;
  }
};
const menuObj = reactive({
  show: false,
  value: "",
  options: [],
  filterString: "",
});

function flattenTreeWithPath(data) {
  const result = [];
  const traverse = (nodes, parentName = "", parentPath = "") => {
    nodes.forEach((node) => {
      // 拼接当前节点的完整路径
      const currentName = parentName ? `${parentName} / ${node.name}` : node.name;
      const currentPath = (parentPath ? `${parentPath}/${node.path}` : node.path).replaceAll("//", "/");

      // 判断是否为末端节点（无子节点或子节点为空数组）
      if (!node.children || node.children.length === 0) {
        // 创建新对象并移除 children 属性
        const { children, ...rest } = node;
        result.push({
          ...rest,
          value: currentPath,
          label: currentName,
        });
      } else {
        // 递归处理子节点
        traverse(node.children, currentName, currentPath);
      }
    });
  };
  traverse(data);
  return result;
}
const menuClickFn = () => {
  menuObj.show = false;
};
const filterMethodFn = (s) => {
  let tmpList = [];
  if (cacheMenuData && cacheMenuData.length > 0 && cacheMenuData[0].children) {
    tmpList = flattenTreeWithPath(cacheMenuData[0].children);
    if (s) {
      tmpList = tmpList.filter((o) => o.label.indexOf(s) !== -1);
      tmpList = tmpList.map((o) => {
        o.label = o.label.replaceAll(s, `<span style='color:#409eff'>${s}</span>`);
        return o;
      });
    }
  }
  menuObj.options = tmpList;
};
const onMenuChangeFn = (url) => {
  menuObj.show = false;
  setTimeout(() => {
    router.push(url);
  }, 100);
};
const onMenuClickFn = () => {
  menuObj.options = cacheMenuData && cacheMenuData.length > 0 && cacheMenuData[0].children ? flattenTreeWithPath(cacheMenuData[0].children) : [];
  menuObj.show = true;
  menuObj.value = "";
  menuObj.filterString = "";
};
const menuCollapse = ref(false);
const isCollapsed = ref(true);
const router = useRouter();
const route = useRoute();

// 用户信息
const user = ref({
  nickName: "admin",
  avatar: "UserFilled",
});
let tenantInfo = {};
const menuData = ref([]);
let cacheMenuData = [];
let pendingHighlightMenu = null;
provide("$tenantInfo", () => tenantInfo);

const initThemeFn = () => {
  request.post(API_CONFIG.infoList.url).then((res) => {
    const userObj = res?.data || {};
    tenantInfo = { ...userObj };
    markContentStr.value = [userObj?.userName, markContent];
    user.value = userObj;
    user.value.avatar = userObj.avatar ? userObj.avatar : "UserFilled";

    if (userObj.roleList.length == 0) {
      ElMessage.warning("请联系管理员");
      return;
    }
    currentRole.value = userObj.roleList[0];
    setCurrentRole(currentRole.value);
    const tenantCode = getTenant();
    if (tenantCode) {
      currentTenant.value = userObj.tenantList.find((ele) => ele.tenantCode === tenantCode);
    } else {
      if (userObj.tenantList?.length > 0) {
        currentTenant.value = userObj.tenantList[0];
      }
    }

    // 将用户信息保存到本地存储
    setUserInfo(userObj);

    // 加载保存的标签页数据
    loadVisitedTabsFromStorage();
    currentRole.value?.id && getMenus(currentRole.value.id);
  });
};

onBeforeMount(() => {
  initThemeFn();
  // 菜单初始化之后需要重新生成动态路由
  // 场景：不同租户切换之后退出登录之后进来，不同租户差异菜单未重新同步生成
  nextTick(() => {
    initDynamicRoutes();
  });
});
// 当前激活的菜单
const activeMenu = computed(() => {
  const { path } = route;
  return path;
});

const resolvePath = (...paths) => {
  return paths.join("/").replaceAll(/\/+/g, "/");
};

// 当前激活的标签页
const activeTab = ref("");
// 访问过的标签页
const visitedTabs = ref([]);
// 缓存的视图
const cachedViews = ref([]);
const key = computed(() => route.path);
const initTabs = () => {
  const { path, meta, name } = route;
  const title = meta.title || t("未命名");
  if (!visitedTabs.value.some((tab) => tab.path === path)) {
    visitedTabs.value.push({
      title,
      path,
      fullPath: route.fullPath,
    });
    saveVisitedTabsToStorage(); // 保存更新
  }
  if (visitedTabs.value.length === 1 && visitedTabs.value[0].title === "_blank") {
    // 如果只有空页面 那么就不展示tabs
    visitedTabs.value = [];
    saveVisitedTabsToStorage(); // 保存更新
  }
  activeTab.value = path;
  saveVisitedTabsToStorage(); // 保存更新
  const foundNode = findNodeById(menuData.value, name);
  if (foundNode && foundNode.isCache == 0) {
    addCachedView();
  }
};

const findNodeById = (tree, name) => {
  for (const node of tree) {
    if (node.name === name) {
      return node;
    }
    if (node.children && node.children.length > 0) {
      const result = findNodeById(node.children, name);
      if (result) {
        return result;
      }
    }
  }
  return null;
};

// 按 name 在菜单树中查找叶子菜单节点（标签页对应页面级菜单，需排除同名目录节点）
const findLeafMenuByName = (tree, name) => {
  for (const node of tree) {
    if (node.name === name && !(node.children && node.children.length > 0)) {
      return node;
    }
    if (node.children && node.children.length > 0) {
      const result = findLeafMenuByName(node.children, name);
      if (result) {
        return result;
      }
    }
  }
  return null;
};

// 添加缓存视图
const addCachedView = () => {
  //   注意 cachedViews存贮的是name ，那么这个name的值要和页码的name相等才行
  //   账号管理页面要缓存；则页面代码需要增加配置；
  //   defineOptions({
  //     name: "账号管理"
  //   })
  //  同时此处 route.name='账号管理'
  const { name } = route;
  if (name && !cachedViews.value.includes(name)) {
    cachedViews.value.push(name);
  }
};

// 处理菜单选择
const handleMenuSelect = (index) => {
  // clearRouteCache(index);
  router.push(index);
};

const clearRouteCache = (path) => {
  let routeParamsCache = getUserRouteParams();
  if (!Array.isArray(routeParamsCache)) {
    routeParamsCache = [];
  }
  // 更新或新增缓存
  const newRouteParamsCache = routeParamsCache.filter((item) => item.label !== path);
  setUserRouteParams(newRouteParamsCache);
};

// 处理标签页点击
const clickTab = (tab) => {
  const path = tab.paneName;
  const targetTab = visitedTabs.value.find((item) => item.path === path);
  if (targetTab) {
    router.push(targetTab.fullPath);
  }
};

// 移除标签页
const closeTagFn = (type) => {
  visitedTabs.value.forEach(({ path, title }) => {
    if (type === "others") {
      if (activeTab.value !== path) {
        removeTab(path);
      }
    } else if (type === "all") {
      removeTab(path);
    } else if (type === "collect") {
      setLocallMenuFn("add", { path, title });
    }
  });
};

// 移除tab
const removeTab = (targetPath) => {
  const tabs = visitedTabs.value;
  let activePath = activeTab.value;

  if (activePath === targetPath) {
    tabs.forEach((tab, index) => {
      if (tab.path === targetPath) {
        const nextTab = tabs[index + 1] || tabs[index - 1];
        if (nextTab) {
          activePath = nextTab.path;
        }
      }
    });
  }

  activeTab.value = activePath;
  visitedTabs.value = tabs.filter((tab) => tab.path !== targetPath);
  saveVisitedTabsToStorage();

  // 如果关闭的是当前标签页，跳转到新激活的标签页
  if (route.path === targetPath) {
    const targetTab = visitedTabs.value.find((tab) => tab.path === activePath);
    if (targetTab) {
      router.push(targetTab.fullPath);
    } else {
      router.push("/_blank");
    }
  }
};

// 退出登录
const logout = () => {
  comCueBox(t("确定要退出登录吗?")).then(() => {
    request.post(API_CONFIG.logOutUrl.url).then((res) => {
      if (res?.code == 200) {
        ElMessage.success(t("退出登录成功"));
        router.push("/login");
        removeToken();
      } else {
        ElMessage.error(res.data.msg);
      }
    });
  });
};

// 跳转个人中心
const toPersonalCenter = () => {
  request.post(API_CONFIG.getUserDetailById.url + `/${user.value.id}`).then((res) => {
    if (res.code == 200) {
      user.value = res.data;
      drawerPannel.value = true;
    } else {
      ElMessage.error("获取用户信息失败！");
    }
  });
};

// 更新用户
const updateUser = (value) => {
  tenantInfo = { ...value };
  request.post(API_CONFIG.infoList.url).then((res) => {
    if (res.code == 200) {
      user.value = res.data;
      drawerPannel.value = false;
    }
  });
};

// 变更角色
const changeRole = () => {
  changeRoleRef.value.open(currentRole.value);
};

// 更新角色
const updateRole = (data) => {
  currentRole.value = data;
  setCurrentRole(data);
  visitedTabs.value = [];
  cachedViews.value = [];
  activeTab.value = "";
  saveVisitedTabsToStorage();
  // 切换角色后菜单会变，置回“未加载”，让路由守卫按新菜单重建动态路由（与 changeTenant 保持一致）。
  resetDynamicRoutes();
  getMenus(data.id);
};

const changeTenant = (data) => {
  // 记录切换前高亮的菜单选项，待新租户菜单加载后判断当前角色是否仍包含它：
  // 包含则恢复高亮，不包含则由 getMenus 初始化到首个菜单。
  pendingHighlightMenu = { name: route.name ? String(route.name) : "", path: route.path };
  currentTenant.value = data;
  setTenant(data.tenantCode);
  getAllDictData();
  tenantComponentKey.value++;
  // 直接清空标签页，不走 closeTagFn("all")：后者会触发 removeTab 的 router.push("/_blank") 副作用，
  // 与 getMenus 里“跳首个菜单”的 push 产生竞态，导致切租户后停在 _blank。
  visitedTabs.value = [];
  cachedViews.value = [];
  activeTab.value = "";
  saveVisitedTabsToStorage();
  resetDynamicRoutes();
  initThemeFn();
};

// 获取菜单
const getMenus = (roleId, isUpdate = true) => {
  request.post(API_CONFIG.getMenuList.url + `/${roleId}`).then(async (res) => {
    if (res.code == 200) {
      const menus = transformMenuData([res.data]);
      if (menus.length == 0) {
        router.push("/404");
        ElMessage.warning("请联系管理员");
        return;
      }
      menuData.value = menus;
      setMenus(JSON.stringify(menus));
      cacheMenuData = JSON.parse(JSON.stringify(menus));

      // 用刚写入的最新菜单重建动态路由，确保下面的 router.push({ name }) 能命中。
      // 切租户/角色后路由已被 resetDynamicRoutes 清空，而 Layout 不会重新挂载（不会触发 onBeforeMount 的预加载），
      // 若不在此重建，push(name) 会因路由未注册而失败、停留在 _blank 或当前页。
      await initDynamicRoutes();

      if (isUpdate && visitedTabs.value.length === 0) {
        // 判断当前角色菜单是否包含切换前高亮的菜单选项
        const highlightNode = pendingHighlightMenu ? findLeafMenuByName(menus, pendingHighlightMenu.name) : null;
        pendingHighlightMenu = null;
        // 不存在则初始化到首个菜单
        const firstName = menus?.[0]?.children?.[0]?.children?.[0]?.name;
        const targetName = highlightNode ? highlightNode.name : firstName;
        if (targetName) {
          try {
            await router.push({ name: targetName });
          } catch (e) {
            // 目标与当前路由同路径时为重复跳转（NavigationFailure），忽略即可
          }
          // 切租户/角色时已清空 tabs；若目标菜单与当前路由同路径，push 是空操作、route.path 不变，
          // 路由 watch 不会触发 initTabs，导致“进入了目标菜单却没有生成 tab”。这里显式补一次（initTabs 自身去重）。
          initTabs();
        } else {
          router.push("/404");
          ElMessage.warning("暂无权限，请联系管理员");
        }
      } else if (visitedTabs.value.length > 0) {
        if (activeTab.value) {
          const targetTab = visitedTabs.value.find((tab) => tab.path === activeTab.value);
          if (targetTab) {
            router.push(targetTab.fullPath);
          }
        }
      }
      // initTabs();
    }
  });
};

// 数据格式转换, 过滤正常的菜单
const transformMenuData = (data) => {
  const transform = (item, parentPathName) => {
    const result = {
      path: item.path || "",
      name: item.menuName || "",
      isCache: item.isCache,
      component: item.component,
      meta: {
        title: item.menuName || "",
        icon: item.icon || "",
      },
    };
    if (item.menuType == "C") {
      result.component = () =>
        import(`@/views/${item.component.replace(/^\//, "")}`).then((m) => {
          m.default.name = item.menuName;
          return m;
        });
    }

    if (item.subMenus && item.subMenus.length > 0) {
      const parentPathName = item.path !== null ? item.path.replace("/", "") : item.path;
      //
      result.children = item.subMenus.filter((subItem) => subItem.status == "0").map((subItem) => transform(subItem, parentPathName));
    } else {
      result.key = `${parentPathName}_${item.path}`.replaceAll("/", "_");
      result.meta.icon = "Handbag";
    }

    return result;
  };

  return data.filter((item) => item.status == "0").map((item) => transform(item, null));
};

const goToWorkplace = () => {
  router.push({ name: "workPlace" });
};

// 监听路由变化
watch(
  () => route.path,
  () => {
    initTabs();
  },
);

// 初始化
// initTabs();

// 菜单更新之后通信出发左侧菜单更新
const { on, off } = useEventBus();
on("update-menu-success", (data) => {
  if (data.msg == "updatedMenu") {
    currentRole.value?.id && getMenus(currentRole.value.id, false);
    // 更新动态路由
    initDynamicRoutes();
    // 更新tab标签页
    const index = visitedTabs.value.findIndex((ele) => ele.path.endsWith(data.data.path));
    if (index !== -1) {
      visitedTabs.value[index].title = data.data.menuName;
    }
  }
});

// 组件卸载时移除监听
onUnmounted(() => {
  off("update-menu-success");
});

// 添加页面卸载前的事件监听，确保数据被保存
window.addEventListener("beforeunload", saveVisitedTabsToStorage);
onUnmounted(() => {
  off("update-menu-success");
  window.removeEventListener("beforeunload", saveVisitedTabsToStorage);
});
</script>

<style>
/* 全局样式 */
.app-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}

.menu-search {
  position: absolute;
  width: 100%;
  height: 100%;
  background: lightgrey;
  z-index: 100;
  opacity: 0.7;
  top: 0;
}

.menu-serach:hover {
  cursor: pointer;
  animation: shake-3d 0.5s ease-in-out;
}

@keyframes shake-3d {
  0% {
    transform: translate3d(0, 0, 0);
  }

  25% {
    transform: translate3d(-4px, 2px, 0);
  }

  50% {
    transform: translate3d(4px, -2px, 0);
  }

  75% {
    transform: translate3d(-4px, 2px, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.el-menu--inline .el-sub-menu__title {
  padding-left: 40px !important;
}

.el-menu--inline .el-menu-item {
  padding-left: 70px !important;
}

/* 顶部导航栏 - 优化样式 */
.navbar {
  height: 50px;
  background: #409eff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: 2px solid #d8dce5;
}

.logo {
  font-size: 18px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
}

.right-menu {
  display: flex;
  align-items: center;
  height: 100%;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
}
.tenant-name {
  color: white;
  width: auto;
}
.user-name {
  margin: 0 8px;
  font-size: 14px;
  color: white;
  display: flex;
  align-items: center;
}
.divider {
  display: inline-block;
}
.nickName {
  font-weight: normal;
  display: inline-block;
}
.roleName {
  font-weight: normal;
  display: inline-block;
}

.el-avatar {
  margin-right: 8px;
  display: inline-block;
}
.h5-entry {
  display: none;
}

/* 主内容区布局 */
.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* 底部备案信息 */
.app-footer {
  flex-shrink: 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fefefe;
  border-top: 1px solid #ebeef5;
  font-size: 14px;
  color: #909399;
}
.app-footer a {
  color: #909399;
  text-decoration: none;
}
.app-footer a:hover {
  color: #409eff;
}

/* 侧边栏 */
.sidebar {
  width: auto !important;
  height: calc(100vh - 40px);
  transition: width 0.3s;
  position: relative;
  overflow: visible !important;
  display: flex;
  flex-direction: column;
}

.sidebar .el-icon {
  color: #409eff;
}

/* 菜单项优化 */
.el-menu {
  border-right: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.el-menu-item,
.el-submenu__title {
  height: 46px;
  line-height: 46px;
}

.el-menu-item.is-active {
  background: rgb(235.9, 245.3, 255);
}

.el-menu-item .el-icon,
.el-submenu__title .el-icon {
  margin-right: 8px;
  width: 18px;
  text-align: center;
  font-size: 16px;
}

/* 主内容区 */
.app-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 标签页容器 */
.tags-view-container {
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.top-tab {
  padding-top: 5px;
  flex: 1;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.el-tabs__nav-prev,
.el-tabs__nav-next {
  top: -4px !important;
}

/* 标签页样式优化 */
.el-tabs--card > .el-tabs__header {
  margin: 0;
  border-bottom: none !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
  margin: 0 5px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none !important;
  margin-right: 3px;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  border-radius: 15px;
  font-size: 14px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #f0f7ff;
  color: #409eff !important;
  border-bottom: 2px solid #989ea4;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  background: #f0f7ff;
  color: grey;
  border-bottom: 2px solid #989ea4;
}

.el-tabs--card > .el-tabs__header .el-tabs__item:hover {
  color: #409eff;
}

/* 内容容器 */
.view-container {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f7fa;
}

/* 过渡动画 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s ease;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* 适配顶部导航栏标题 */
.pc-title {
  display: block;
}
.mobile-title {
  display: none;
}

@media screen and (max-width: 760px) {
  .pc-title {
    display: none;
  }
  .mobile-title {
    display: block;
  }
  .tenant-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .divider {
    display: none !important;
  }
  .el-avatar {
    display: none !important;
  }
  .roleName {
    display: none;
  }
  .h5-entry {
    display: block;
    font-size: 12px;
    margin-left: 5px;
    color: white;
  }
}
</style>
<style>
:focus-visible {
  outline: none !important;
  border: none !important;
}
</style>
